import { useState, useContext, useEffect } from 'react';
import { PageLayout } from '@/components/PageLayout';
import { TEOLoader } from '@teo/components';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import BreadCrumbsHeader from '@/components/BreadCrumbsHeader';
import { NavContext } from '@/components/NavContext';
import { PageUrlContext } from '@/components/Contexts/PageUrlContext';
import { useMobile, parseQueryString, parseCourseType } from '@/util';
import { createSidebar } from '../../constants/sidebar.constants';
import SidebarNavigation from '@/components/SidebarNavigation';
import { CreateNewPublication } from '@/components/CreateNewPublication/CreateNewPublication';
import TypeCourse from '@/components/CreateNewPublication/TypeCourse';
import { Userwithorganisationwithidps } from '@/models';
import { AuthContext } from '@/components/Contexts/AuthContext';
import i18n from 'i18next';

function CreatePage() {
  const { collapsed, navDisabled, submenu, leftSidebar, headerDisabled } =
    useContext(NavContext);
  const { newPage } = useContext(PageUrlContext);
  const { auth } = useContext(AuthContext);
  const { trainingId, themeId } = useParams();

  const authLang: any = auth?.user.lang;
  const authOrg: any = auth?.user?.activeOrganisationId;

  const queries = parseQueryString(document.location.search) as {
    [key: string]: string;
  };

  const isMobile = useMobile();
  const showNav = !navDisabled && ((submenu && !collapsed) || !isMobile);
  const showContent = collapsed || !isMobile;
  const [isOpenTypeModal, setIsOpenTypeModal] = useState(
    !!queries['courseType']
  );
  const [template, setTemplate] = useState('theory');
  const [typeCourse, setTypeCourse] = useState(
    parseCourseType(queries['courseType'] || 'course')
  );

  const [goToCreate, setGoToCreate] = useState(false);
  const [goToCreateLP, setGoToCreateLP] = useState(false);
  const [publicationId, setPublicationId] = useState();
  const [learningpathId, setLearningpathId] = useState();

  const [loadeNewPublication, setLoadeNewPublication] = useState(false);

  const [hideNavbar, setHideNavbar] = useState(false);

  //insufficiënt role redirect
  const authUser = auth?.user as Userwithorganisationwithidps;
  const navigate = useNavigate();
  useEffect(() => {
    const role = Math.max(
      authUser?.activeOrganisationRole || 0,
      authUser?.role || 0
    );
    if (role <= 20) {
      navigate(`/${i18n.language}/noaccess`);
    }
  }, []);

  useEffect(() => {
    if (isOpenTypeModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [isOpenTypeModal]);

  useEffect(() => {
    if (goToCreate) {
      setLoadeNewPublication(false);
      setIsOpenTypeModal(false);
      navigate(`/${authLang}/create/${authOrg}/courses/${publicationId}`);
    }
  }, [goToCreate]);

  useEffect(() => {
    if (goToCreateLP) {
      setLoadeNewPublication(false);
      setIsOpenTypeModal(false);
      navigate(
        `/${authLang}/create/${authOrg}/learning-paths/${learningpathId}`
      );
    }
  }, [goToCreateLP]);

  if (navDisabled) return <Outlet />;
  return (
    <PageLayout>
      {showNav && !leftSidebar && (
        <PageLayout.Sidebar
          key={newPage}
          className={`${hideNavbar && 'md:w-max lg:w-max'}`}
        >
          <CreateNewPublication
            setIsOpenTypeModal={setIsOpenTypeModal}
            isMobile={isMobile}
            setTypeCourse={setTypeCourse}
            authUser={authUser}
          />
          <SidebarNavigation
            items={createSidebar}
            setHideNavbar={setHideNavbar}
            hideNavbar={hideNavbar}
          />
        </PageLayout.Sidebar>
      )}
      <div
        className={`${showContent ? '' : 'hidden'} ${
          trainingId || leftSidebar || themeId
            ? 'min-h-[100vh] w-full lg:min-h-[calc(100vh_-_150px)]'
            : 'mx-auto min-h-[100vh] w-full max-w-6xl lg:min-h-[calc(100vh_-_150px)]'
        } `}
      >
        <PageLayout.Content>
          {/* {!(leftSidebar || headerDisabled) && !isMobile && (
            <BreadCrumbsHeader />
          )} */}
          <Outlet />
        </PageLayout.Content>
        {loadeNewPublication && (
          <div className="fixed inset-0 z-[201] m-auto flex min-h-screen min-w-full bg-white/75 p-10">
            <div className="m-auto">
              <TEOLoader
                loaderSrc="/images/TEOloader.gif"
                className="w-[100px]"
              />
            </div>
          </div>
        )}
        {isOpenTypeModal && (
          <TypeCourse
            setIsOpenTypeModal={setIsOpenTypeModal}
            setTemplate={setTemplate}
            template={template}
            typeCourse={typeCourse}
            setGoToCreate={setGoToCreate}
            setGoToCreateLP={setGoToCreateLP}
            setPublicationId={setPublicationId}
            setLearningpathId={setLearningpathId}
            publicationId={publicationId}
            setLoadeNewPublication={setLoadeNewPublication}
          />
        )}
      </div>
    </PageLayout>
  );
}

export default CreatePage;
